import {WorkflowTargetModel} from "../workflow/models/workflow-target.model";
import {UserModel, userModelListFactory} from "../types/user.model";
import {AddressModel, addressModelFactory} from "../address/address.model";
import {ContactModel, contactModelFactory} from "../contact/contact.model";
import {
  InstallationInstructions,
  installationInstructionsModelFactory,
} from "../installation-dialog/installation.model";
import {
  ProjectOffHoldIncrementModel,
  ProjectOffHoldIncrementModelFactory,
} from "../workflow/project/project-off-hold.model";
import {masterAgreementShortNameLookup} from "./master-agreement-status";
import _ = require("lodash");
import {String} from "aws-sdk/clients/acm";
import * as moment from "moment";

interface MpcContactsAddressesModel {
  addresses: {
    endCustomerBpid: string;
    billToCustomerBpid: string;
    payerCustomerBpid: string;
  };
  contacts: {
    billToContactBpid: string;
    invoiceContactBpid: string;
  };
}

export interface ProjectModel extends WorkflowTargetModel {
  id?: string;
  name?: string;
  countryId?: string;
  country?: any;
  resellerBpId?: string;
  resellerName?: string;
  customerBpId?: string;
  customerName?: string;
  targetSystem?: string;
  currentMaStatus?: string;
  uniqueId?: string;
  opportunityId?: string;
  status?: string;
  startDate?: string;
  customerKickoffDate?: string;
  estimatedProjectClosureDate?: string;
  actualProjectClosureDate?: string;
  estimatedTransitionDate?: number;
  actualTransitionDate?: number;
  estimatedCompletionDate?: string;
  firstInstallDate?: string;
  firstOrderDate?: string;
  totalCustomerValue?: number;
  currency?: string;
  companyCodeGroup?: string;
  standardCompanyCode?: string;
  users?: UserModel[];
  ampId?: string;
  csa?: string;
  msId?: string;
  orderAcceptance?: boolean;
  orderAcceptanceDisableReason?: string;
  orderAcceptanceDisableDate?: string;
  sourceDocumentationLink?: string;
  initialBillingDate?: number;
  dashboardMilestones?: any[];
  dashboardIssues?: any[];
  customerErpNumber?: string;
  address?: AddressModel;
  billToAddress?: AddressModel;
  soldToAddress?: AddressModel;
  payerAddress?: AddressModel;
  endUserAddress?: AddressModel;
  endCustomerAddress?: AddressModel;
  billToContact?: ContactModel;
  invoiceContact: ContactModel;
  hpInvoiceContact: ContactModel;
  hpSalesRepContact: ContactModel;
  hpContractAdminContact: ContactModel;
  hpAccDeliveryMgrContact: ContactModel;
  workflowId?: string;
  deployedDevices?: number;
  orderedDevices?: number;
  requestedOrdersCount?: number;
  requestedBulkOrdersCount?: number;
  siteCount?: number;
  orderCount?: number;
  bulkOrderCount?: number;
  deploymentCount?: number;
  plannedDevices?: number;
  installationInstructions?: InstallationInstructions;
  qualityChecklist?: string[];
  k2Customer?: string;
  expenses?: any[];
  opgNumber?: string;
  saLetter?: string;
  shippingLabel1?: string;
  shippingLabel2?: string;
  totalDevices?: number;
  enableCatalogPricing?: boolean;
  k2CustomerName?: string;
  enableBulkOrdering?: boolean;
  customerPin?: string;
  siteNameStructure?: string;
  purchaseOrderSplit: string;
  sourceName?: string;
  partnerPurchaseOrders?: any;
  rejected?: boolean;
  rejectedReason?: string;
  rejectedDate?: string;
  allowUnRejectProject?: boolean;
  holdDate?: string;
  estimatesIncrement?: ProjectOffHoldIncrementModel;
  orderAcceptanceCompleteDate?: string;
  geo_region_id?: string;
  allowSetGeoRegion: boolean;
  requireMaiPagecounts: boolean;
  workspaces: any[];
  deliveryInformation?: string;
  defaultContractAccountId: string;
  includeReseller: boolean;
  fleetId?: string;
  fleetName?: string;
  // Simplify
  vendorContractAccNumber?: string;
  masterAgreementDescription?: string;
  maStartDate?: string;
  billingCycle?: string;
  billingFrequency?: string;
  commercialityCode?: string;
  globalDeal?: string;
  globalDealClassification?: string;
  podRequired?: boolean;
  inadvanceInarrears?: string;
  coTerminous?: boolean;
  coTerminousDate?: string;
  billingModelSplit?: boolean;
  businessModelSplit?: boolean;
  chargeTypeSplit?: boolean;
  endUserSplit?: boolean;
  titleStatusSplit?: boolean;
  itsmCustomerId?: string;
  resellerCustomerId?: string;
  salesOrganization?: string;
  isMpc?: boolean;
  mpcContactsAddressesBpids?: MpcContactsAddressesModel;
  supplyRoutingId?: string;
  customLabels?: any;
  customLabel1?: string;
  customLabel2?: string;
  customLabel3?: string;
  customLabel4?: string;
  customLabel5?: string;
  customLabel6?: string;
  customLabel7?: string;
  customLabel8?: string;
  customLabel9?: string;
  customLabel10?: string;
  customTransactionStatus?: number;
  billFromStructure?: string;
  billFromBPIDId?: string;
  actualDeploymentCompletionDate?: string;
  isFedLLC?: boolean;
  toCreateFleetName?: boolean;
}

export interface ContractAccountRequests {
  error?: any;
  contractAccountName?: string;
  statusInformation?: any;
  filename?: string;
  subscription?: any;
}

export interface BrokerApiContractAccountDataModel {
  currency: string;
  businessPartner: string;
  contractAccountId: string;
  contractAccountCategory: string;
  paymentTerms: string;
  incomingPaymentMethod: string;
  correspondenceVariant: string;
  billToParty: string;
  correspondenceRecipient: string;
  contractAccountName: string;
  accountDeterminationId: string;
  companyCodeGroup: string;
  standardCompanyCode: string;
  correspondenceType: string;
  outgoingPaymentMethod: string;
  invoiceScheduling: string;
  accountClass: string;
  alternatePayer: string;
  incomingCreditCard: string;
  billingCycle: string;
  startDateOfFirstBillingPeriod: string;
  contractAccountNumberInLegacy: string;
  addressDetails?: object;
  itsmCustomerId: string;
  invoiceDistribuitionMethod: string;
  status?: boolean;
  caStatus?: string;
  projectId?: string;
  existingCaName?: string[];
  isMultipleCAEnabled?: boolean;
  opportunityId: string;
  resellerCustomerId?: string;
  contracts?:any;
  isCASelected?:boolean;
  opportunityIds?: string;
  exchangeRateType?:string;
  exchangeRate?:string;
}

export interface ItsmContractAccountDataModel {
  "businessPartner": string;
  "paymentTerms": string;
  "incomingPaymentMethod": string;
  "outgoingPaymentMethod": string;
  "invoiceScheduling": string;
  "contractAccountCategory": string;
  "currency": string;
  "correspondenceVariant": string;
  "contractAccountId": string;
  "accountDeterminationId": string;
  "companyCodeGroup": string;
  "standardCompanyCode": string;
  "contractAccountName": string;
  "formDetermination": string;
  "status": boolean;
}

function parseDateFromJSON(date) {
  if (!date) return null;
  const matches = `${date}`.match(/^([0-9]{4}-[0-9]{2}-[0-9]{2})T?/i);
  if (!matches) return null;
  return matches[1] || null;
}

function toNumber(obj): number {
  const f = parseFloat(obj);
  if (Number.isNaN(f)) return undefined;
  return f;
}

const contractAccountDefaults = Object.freeze({
  currency: "USD",
  incomingPaymentMethod: "D",
  outgoingPaymentMethod: "S",
  companyCodeGroup: "US11",
  standardCompanyCode: "US11",
});

export function brokerApiContractAccountDataModelFactory(json?: any): BrokerApiContractAccountDataModel {
  json = json || {};
  return {
    currency: json.currency || contractAccountDefaults.currency || "",
    businessPartner: json.businessPartner || "",
    contractAccountId: json.contractAccountId || "",
    contractAccountCategory: json.contractAccountCategory || "",
    paymentTerms: json.paymentTerms || "",
    incomingPaymentMethod: json.incomingPaymentMethod || contractAccountDefaults.incomingPaymentMethod || "",
    correspondenceVariant: json.correspondenceVariant || "",
    billToParty: json.billToParty || "",
    correspondenceRecipient: json.correspondenceRecipient || "",
    contractAccountName: json.contractAccountName || "",
    accountDeterminationId: json.accountDeterminationId || "",
    companyCodeGroup: json.companyCodeGroup || contractAccountDefaults.companyCodeGroup || "",
    standardCompanyCode: json.standardCompanyCode || contractAccountDefaults.standardCompanyCode || "",
    correspondenceType: json.correspondenceType || "",
    outgoingPaymentMethod: json.outgoingPaymentMethod || contractAccountDefaults.outgoingPaymentMethod || "",
    invoiceScheduling: json.invoiceScheduling || "",
    accountClass: json.accountClass || "",
    alternatePayer: json.alternatePayer || "",
    incomingCreditCard: json.incomingCreditCard || "",
    billingCycle: json.incomingCreditCard || "",
    startDateOfFirstBillingPeriod: json.startDateOfFirstBillingPeriod || "",
    contractAccountNumberInLegacy: json.contractAccountNumberInLegacy || "",
    addressDetails: json.addressDetails || null,
    itsmCustomerId: json.itsmCustomerId || null,
    invoiceDistribuitionMethod: json.invoiceDistribuitionMethod || "",
    invoiceLanguage: json.invoiceLanguage || "",
    status: json.status || "",
    caStatus: json.caStatus || "",
    projectId: json.projectId || "",
    existingCaName: json.existingCaName || [],
    isMultipleCAEnabled: json.isMultipleCAEnabled || false,
    opportunityId: json.opportunityId || "",
    resellerCustomerId: json.resellerCustomerId || "",
    exchangeRateType:json.exchangeRateType || "",
    exchangeRate:json.exchangeRate || "",
    soldToOptions: json.soldToOptions || [],
  } as BrokerApiContractAccountDataModel;
}

export function itsmContractAccountData(json?: any): ItsmContractAccountDataModel {
  json = json || {};
  return {
    businessPartner: json.businessPartner || "",
    paymentTerms: json.paymentTerms.id || "",
    incomingPaymentMethod: json.incomingPaymentMethod.id || "",
    outgoingPaymentMethod: json.outgoingPaymentMethod.id || "",
    invoiceScheduling: json.invoiceScheduling.id || "",
    contractAccountCategory: json.contractAccountCategory.id || "",
    currency: json.currency || "",
    correspondenceVariant: json.correspondenceVariant.id || "",
    contractAccountId: json.contractAccountId || "",
    accountDeterminationId: json.accountDeterminationId.id || "",
    companyCodeGroup: json.companyCodeGroup || "",
    standardCompanyCode: json.standardCompanyCode || "",
    contractAccountName: json.contractAccountName || "",
    formDetermination: json.formDetermination.id || "",
    status: json.status || false,
  };
}
export function projectGqlModelFac(json?: any): ProjectModel {
  const projects = projectModelFactory(json.body.data.project[0]);
  if (json.country && json.country.countryName) {
    projects.country.countryName = json.country.countryName;
  }
  if (json.country && json.country.geoRegionId) {
    projects.country.geo_region_id = json.country.geoRegionId;
  }
  return projects;
}
export function projectGqlModelFactory(json?: any): ProjectModel {
  const projects = projectModelFactory(_.first(json.data["projects"]));
  projects.country.countryName = _.first(json.data["projects"])["countryName"];
  projects.country.geo_region_id = _.first(json.data["projects"])["geoRegionId"];
  return projects;
}
function getTransitionDate(startDate: any, estimatedDate: string) {
  const a = moment(startDate);
  const b = moment(estimatedDate);
  return b.diff(a, 'months');
}
export function projectModelFactory(json?: any): ProjectModel {
  json = json || {};

  if (!json.id) {
    json.startDate = new Date().toISOString();
    json.status = "open";
  }

  if (json.country) {
    json.countryId = json.country.countryId;
    json.country.geoRegionId = json.country.geo_region_id;
  }

  if (json.dorData) {
    json.multiYearPoType = json.dorData.multiYearPoType;
    json.multiYearTermDuration = json.dorData.multiYearTermDuration;
    json.prepaidFieldOnDorTab = json.dorData.prepaidFieldOnDorTab;
    json.previousDocument = json.dorData.previousDocument;
    json.renewal = json.dorData.renewal;
    json.legacyReportedDate = json.dorData.legacyReportedDate;
    json.legacyReportedThruDate = json.dorData.legacyReportedThruDate;
    json.endCustomerSplit = json.dorData.endCustomerSplit;
    json.payerSplit = json.dorData.payerSplit;
    json.poNumberSplit = json.dorData.poNumberSplit;
    json.shipToSplit = json.dorData.shipToSplit;
    json.legacyDocumentType = json.dorData.legacyDocumentType;
    json.legacyDocumentNumber = json.dorData.legacyDocumentNumber;
  }

  return {
    id: json.id,
    name: json.name || "",
    countryId: json.countryId || "",
    country: json.country || {},
    status: json.status || "",
    resellerBpId: json.resellerBpId || "",
    resellerName: json.resellerName || "",
    customerBpId: json.customerBpId || "",
    customerName: json.customerName || "",
    uniqueId: json.uniqueId || "",
    targetSystem: json.targetSystem || "",
    currentMaStatus: masterAgreementShortNameLookup[json.currentMaStatus] || "MA unknown",
    opportunityId: json.opportunityId || "",
    startDate: parseDateFromJSON(json.startDate) || "",
    customerKickoffDate: parseDateFromJSON(json.customerKickoffDate) || "",
    estimatedProjectClosureDate: parseDateFromJSON(json.estimatedProjectClosureDate) || "",
    actualProjectClosureDate: parseDateFromJSON(json.actualProjectClosureDate) || "",
    estimatedTransitionDate: toNumber(json.estimatedTransitionDate) || +getTransitionDate(json.startDate, json.estimatedProjectClosureDate) || 0,
    actualTransitionDate: toNumber(json.actualTransitionDate) || +getTransitionDate(json.startDate, json.actualProjectClosureDate) || 0,
    estimatedCompletionDate: parseDateFromJSON(json.estimatedCompletionDate) || "",
    firstInstallDate: parseDateFromJSON(json.firstInstallDate) || "",
    firstOrderDate: parseDateFromJSON(json.firstOrderDate) || "",
    totalCustomerValue: toNumber(json.totalCustomerValue),
    currency: json.currency || "",
    companyCodeGroup: json.companyCodeGroup || "",
    standardCompanyCode: json.standardCompanyCode || "",
    users: userModelListFactory(json.users),
    ampId: json.ampId || "",
    csa: json.csa || "",
    msId: json.msId || "",
    orderAcceptance: !!json.orderAcceptance,
    orderAcceptanceDisableReason: json.orderAcceptanceDisableReason || "",
    orderAcceptanceDisableDate: json.orderAcceptanceDisableDate || "",
    sourceDocumentationLink: json.sourceDocumentationLink,
    initialBillingDate: json.initialBillingDate,
    billingStart: json.billingStart,
    dashboardMilestones: json.dashboardMilestones || [],
    dashboardIssues: json.dashboardIssues || [],
    customerErpNumber: json.customerErpNumber || "",
    address: addressModelFactory(json.address),
    billToAddress: addressModelFactory(json.billToAddress),
    soldToAddress: addressModelFactory(json.soldToAddress),
    payerAddress: addressModelFactory(json.payerAddress),
    endUserAddress: addressModelFactory(json.endUserAddress),
    endCustomerAddress: addressModelFactory(json.endCustomerAddress),
    billToContact: contactModelFactory(json.billToContact),
    invoiceContact: contactModelFactory(json.invoiceContact),
    hpInvoiceContact: contactModelFactory(json.hpInvoiceContact),
    hpSalesRepContact: contactModelFactory(json.hpSalesRepContact),
    hpContractAdminContact: contactModelFactory(json.hpContractAdminContact),
    hpAccDeliveryMgrContact: contactModelFactory(json.hpAccDeliveryMgrContact),
    workflowId: json.workflowId || "",
    deployedDevices: toNumber(json.deployedDevices),
    orderedDevices: toNumber(json.orderedDevices),
    requestedOrdersCount: +json.requestedOrdersCount || 0,
    requestedBulkOrdersCount: +json.requestedBulkOrdersCount || 0,
    siteCount: toNumber(json.siteCount),
    orderCount: +json.orderCount || 0,
    bulkOrderCount: +json.bulkOrderCount || 0,
    deploymentCount: toNumber(json.deploymentCount),
    plannedDevices: toNumber(json.plannedDevices),
    installationInstructions: installationInstructionsModelFactory(json.installationInstructions),
    qualityChecklist: json.qualityChecklist || [],
    k2Customer: json.k2Customer || "",
    expenses: json.expenses || [],
    opgNumber: json.opgNumber || "",
    shippingLabel1: json.shippingLabel1 || json.customShippingLabel1 || "",
    shippingLabel2: json.shippingLabel2 || json.customShippingLabel2 || "",
    totalDevices: toNumber(json.totalDevices),
    enableCatalogPricing: json.enableCatalogPricing || false,
    k2CustomerName: json.k2CustomerName || "",
    enableBulkOrdering: json.enableBulkOrdering || false,
    customerPin: json.customerPin || "",
    siteNameStructure: json.siteNameStructure || "",
    sourceName: json.sourceName || "",
    partnerPurchaseOrders: json.partnerPurchaseOrders || [],
    rejected: !!json.rejected,
    rejectedReason: json.rejectedReason || "",
    rejectedDate: json.rejectedDate || "",
    allowUnRejectProject: !!json.allowUnRejectProject,
    holdDate: json.holdDate || "",
    estimatesIncrement: ProjectOffHoldIncrementModelFactory(json.estimatesIncrement),
    orderAcceptanceCompleteDate: parseDateFromJSON(json.orderAcceptanceCompleteDate) || "",
    geo_region_id: json.geo_region_id || "", // eslint-disable-line @typescript-eslint/camelcase
    allowSetGeoRegion: !!json.allowSetGeoRegion,
    requireMaiPagecounts: !!json.requireMaiPagecounts,
    multiYearPoType: json.multiYearPoType || "",
    multiYearTermDuration: json.multiYearTermDuration || "",
    prepaidFieldOnDorTab: json.prepaidFieldOnDorTab || "",
    previousDocument: json.previousDocument || "",
    renewal: json.renewal || "",
    legacyReportedDate: json.legacyReportedDate || "",
    legacyReportedThruDate: json.legacyReportedThruDate || "",
    legacyDocumentType: json.legacyDocumentType || "",
    legacyDocumentNumber: json.legacyDocumentNumber || "",
    endCustomerSplit: json.endCustomerSplit || "",
    payerSplit: json.payerSplit || "",
    poNumberSplit: json.poNumberSplit || "",
    shipToSplit: json.shipToSplit || "",
    workspaces: json.workspaces || "",
    deliveryInformation: json.deliveryInformation || "",
    defaultContractAccountId: json.defaultContractAccountId || "",
    includeReseller: json.includeReseller || false,
    fleetId: json.fleetId || "",
    fleetName: json.fleetName || "",
    // Simplify
    vendorContractAccNumber: json.vendorContractAccNumber || "",
    masterAgreementDescription: json.masterAgreementDescription || "",
    maStartDate: parseDateFromJSON(json.maStartDate) || "",
    billingCycle: json.billingCycle || "",
    billingFrequency: json.billingFrequency || "",
    commercialityCode: json.commercialityCode || "",
    globalDeal: json.globalDeal || "",
    globalDealClassification: json.globalDealClassification || "",
    podRequired: json.podRequired || false,
    inadvanceInarrears: json.inadvanceInarrears || "",
    coTerminous: !!json.coTerminous,
    coTerminousDate: parseDateFromJSON(json.coTerminousDate) || "",
    billingModelSplit: json.billingModelSplit || "",
    businessModelSplit: json.businessModelSplit || false,
    chargeTypeSplit: json.chargeTypeSplit || false,
    endUserSplit: json.endUserSplit || false,
    titleStatusSplit: json.titleStatusSplit || false,
    itsmCustomerId: json.itsmCustomerId || "",
    resellerCustomerId: json.resellerCustomerId || "",
    purchaseOrderSplit: json.purchaseOrderSplit,
    salesOrganization: json.salesOrganization || "",
    saLetter: json.saLetter || "",
    isMpc: json.isMpc || false,
    mpcContactsAddressesBpids: json.mpcContactsAddressesBpids || null,
    supplyRoutingId: json.supplyRoutingId || null,
    customLabel1: json.customLabel1 || (json.customLabels ? json.customLabels.custom1 : ''),
    customLabel2: json.customLabel2 || (json.customLabels ? json.customLabels.custom2 : ''),
    customLabel3: json.customLabel3 || (json.customLabels ? json.customLabels.custom3 : ''),
    customLabel4: json.customLabel4 || (json.customLabels ? json.customLabels.custom4 : ''),
    customLabel5: json.customLabel5 || (json.customLabels ? json.customLabels.custom5 : ''),
    customLabel6: json.customLabel6 || (json.customLabels ? json.customLabels.custom6 : ''),
    customLabel7: json.customLabel7 || (json.customLabels ? json.customLabels.custom7 : ''),
    customLabel8: json.customLabel8 || (json.customLabels ? json.customLabels.custom8 : ''),
    customLabel9: json.customLabel9 || (json.customLabels ? json.customLabels.custom9 : ''),
    customLabel10: json.customLabel10 || (json.customLabels ? json.customLabels.custom10 : ''),
    customTransactionStatus: json.customTransactionStatus || null,
    billFromStructure: json.billFromStructure || null,
    billFromBPIDId: json.billFromBPIDId || null,
    actualDeploymentCompletionDate: json.actualDeploymentCompletionDate || null,
    isFedLLC: json.isFedLLC ? true : false
  } as ProjectModel;
}

export function brokerApiContractAccountDataModelListFactory(json?: any): BrokerApiContractAccountDataModel[] {
  return Array.from(json || [])
    .map(brokerData => brokerApiContractAccountDataModelFactory(brokerData));
}

export function itsmApiContractAccountDataFactory(json?: any): ItsmContractAccountDataModel[] {
  return Array.from(json || [])
    .map(itsmData => itsmContractAccountData(itsmData));
}

export interface BrokerContractAccountReturnDataModel {
  success: boolean;
  errorMessage: string;
  contractAccountData: BrokerApiContractAccountDataModel[];
}

export interface ItsmContractAccountReturnDataModel {
  success: boolean;
  errorMessage: string;
  contractAccountData: ItsmContractAccountDataModel[];
}

export function brokerApiContractAccountReturnDataFactory(json?: any) {
  json = json || [];

  return {
    success: json.success || false,
    errorMessage: json.errorMessage || "",
    contractAccountData: brokerApiContractAccountDataModelListFactory(json.contractAccountData),
  } as BrokerContractAccountReturnDataModel;
}

export function ItsmContractAccountDataFactory(json?: any) {
  json = json || [];
  return {
    success: json.success || false,
    errorMessage: json.errorMessage || "",
    contractAccountData: itsmApiContractAccountDataFactory(json.contractAccountData),
  } as ItsmContractAccountReturnDataModel;
}

export const projectUpdateKeys = ["id",
  "name",
  "countryId",
  "status",
  "startDate",
  "resellerBpId",
  "resellerName",
  "customerBpId",
  "uniqueId",
  "targetSystem",
  "opportunityId",
  "customerKickoffDate",
  "estimatedProjectClosureDate",
  "actualProjectClosureDate",
  "actualDeploymentCompletionDate",
  "estimatedCompletionDate",
  "totalCustomerValue",
  "sourceDocumentationLink",
  "initialBillingDate",
  "dashboardMilestones",
  "dashboardIssues",
  "installationInstructions",
  "qualityChecklist",
  "expenses",
  "customerPin",
  "sourceName",
  "partnerPurchaseOrders",
  "estimatesIncrement",
  "requireMaiPagecounts",
  "smartsheetWorkspace",
  "deliveryInformation",
  "customerName",
  "includeReseller",
  "itsmCustomerId",
  "k2Customer",
  "enableBulkOrdering",
  "fleetId",
  "fleetName",
  "supplyRoutingId",
  "customLabel1",
  "customLabel2",
  "customLabel3",
  "customLabel4",
  "customLabel5",
  "customLabel6",
  "customLabel7",
  "customLabel8",
  "customLabel9",
  "customLabel10",
  "toCreateFleetName",
];

export const createContractAccountKeys = [
  "currency",
  "businessPartner",
  "contractAccountId",
  "contractAccountCategory",
  "paymentTerms",
  "incomingPaymentMethod",
  "correspondenceVariant",
  "billToParty",
  "correspondenceRecipient",
  "contractAccountName",
  "accountDeterminationId",
  "companyCodeGroup",
  "standardCompanyCode",
  "correspondenceType",
  "outgoingPaymentMethod",
  "invoiceScheduling",
  "accountClass",
  "alternatePayer",
  "incomingCreditCard",
  "billingCycle",
  "startDateOfFirstBillingPeriod",
  "contractAccountNumberInLegacy",
  "itsmCustomerId",
  "invoiceDistribuitionMethod",
  "invoiceLanguage",
  "opportunityId",
  "resellerCustomerId",
  "projectId",
  "exchangeRateType",
  "exchangeRate"
];

export interface MasterAgreementStatus {
  projectId: string;
  currentMaStatus: number;
  projectStatus: string;
  lastMasterAgreementReturnStatus: {
    version: number;
    receivedDate: string | null;
    returnResults: {
      messageTimestamp: string | null;
      messageId: string | null;
      messageTransactionId: string | null;
      requestType: string | null;
      status: string | null;
      errorMessage: string | null;
      errors: {
        kind: string;
        count: number;
        message: string;
      }[];
    };
  };
  currentMaInternalId: string | null;
  externalId: string;
  opportunityId: string;
  maStartDate: string;
  custPoItemNo: string;
  masterAgreementDescription: string;
  submittedTs: string;
  submittedBy: string;
  pendingMaTransactionId: string | null;
  isTemplateDartImport: boolean;
  itsmCustomerName: string;
  itsmCustomerId: string;
  hasHardErrors: number;
  validationErrors: string[];
  productsNeedingExport: number;
  independentServicesNeedingOrders: number;
  solutions: {
    state: string;
    deviceId: string;
    masterKey: string;
    typeId: number;
    currentPoStatus: number;
    dartDealId: string;
    dartDealVersion: string;
    solutionId: string;
    productNumber: string;
    customId: string;
    itemDesc: string;
    customText: string;
    sapProductId: string;
    legacyProductDescription: string;
    type: string;
  }[];
  isAppend: boolean;
}

export interface TransactionResponse {
  status: number;
  extras: {
    messageTimestamp: string;
    messageId: string;
    messageTransactionId: string;
    requestType: string;
    status: string;
    errorMessage: string;
    errors: {
      kind: string;
      count: number;
      message: string;
    }[];
  };
}
